var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56216 12.6253C2.94054 13.0037 3.53264 13.0381 3.94988 12.7285L4.06942 12.6253L9 7.69524L13.9306 12.6253C14.309 13.0037 14.9011 13.0381 15.3183 12.7285L15.4378 12.6253C15.8162 12.247 15.8506 11.6549 15.541 11.2376L15.4378 11.1181L9.75363 5.43387C9.37525 5.05549 8.78315 5.0211 8.36591 5.33068L8.24637 5.43387L2.56216 11.1181C2.14595 11.5343 2.14595 12.2091 2.56216 12.6253Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.61deb25827510528376a52705b2b1656.svg";
export { ForwardRef as ReactComponent };